import { LatitudeLongitudeService } from './../../dashboard/new-case-map/latitudeLongitude.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NbToastrService } from '@nebular/theme';
import { CaseManagementService } from '../../../services/caseManagement.service';

@Component({
  selector: 'add-attachment',
  templateUrl: './add-attachment.component.html',
  styleUrls: ['./add-attachment.component.css']
})
export class AddAttachmentComponent implements OnInit {

  purpose = 1121;
  fileData: File;
  showAlert = false;
  loading: boolean;
  purposeOptions: any;

  constructor(
    public dialogRef: MatDialogRef<AddAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public woKey: any,
    private caseManagementService: CaseManagementService,
    private toasterService: NbToastrService,
    private latitudeLongitudeService: LatitudeLongitudeService
  ) { }

  ngOnInit(): void {
    this.getPurposeOptions();
  }

  getPurposeOptions() {
    this.loading = true
    this.caseManagementService.getCODOptions(68).subscribe(res => {
      this.loading = false;
      this.purposeOptions = res;
    });
  }

  onClose(value: boolean): void {
    this.dialogRef.close(value);
  }

  onFileSelectedMethod(fileInput) {
    this.showAlert = false;
    this.fileData = <File>fileInput.target.files[0];
  }

  onUploadFile() {
    this.showAlert = false;
    if (this.fileData == undefined || this.fileData == null) {
      this.showAlert = true;
      return false;
    }

    const objSendEmailParams = {
      woKey: this.woKey,
      purpose: this.purpose.toString()
    };
    const formData = new FormData();
    formData.append("file", this.fileData);
    formData.append('inviteRequest', JSON.stringify(objSendEmailParams));
    this.loading = true;
    if (this.woKey) {
      this.caseManagementService.uploadAttachment(formData).subscribe(res => {
        this.loading = false;
        if (res.status) {
          this.toasterService.success('', res.message);
          this.onClose(true);
        } else {
          this.toasterService.warning('', res.message);
        }
      }, () => {
        this.loading = false;
        this.toasterService.warning('', 'Failed to upload.');
      });
    } else {
      this.loading = false;
      this.latitudeLongitudeService.setAttachmentFile(this.fileData, this.purpose.toString());
      this.onClose(true);
      this.toasterService.success('', 'Attachment added');
    }

  }

}
